type Credentials = {
  code: string;
};

const credentials: Credentials = {
  code: "",
};

export type { Credentials };

export { credentials };
